import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'

export const useNavigationContainerStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    position: 'relative',
    color: theme.palette.common.white,
  },
  contentContainer: {
    position: 'relative',
    flexGrow: 1,
    overflow: 'auto',
    display: 'flex', // <--- this could cause heavy animation lag
    flexDirection: 'column', // <--- this could cause heavy animation lag
  },
  content: {
    overflowX: 'hidden',
    position: 'relative',
    height: '100%',
    flex: 1,
    background: 'transparent linear-gradient(-60deg, #868686 0%, #4B4B4B 100%) 0% 0% no-repeat padding-box',
  },
}))
